const cn = {
  privacyPolicy: {
    text: "隱私政策",
  },
  motionSensorsPopUpText: {
    text: "AR需要訪問設備運動傳感器",
  },
  motionSensorSpanNo: {
    text: "取消",
  },
  motionSensorSpanYes: {
    text: "繼續",
  },
  ageGatePopUpText: {
    text: "您是否已超過您所在國家" + "<br/>" + "地區的法定最低飲酒年齡?",
  },
  ageGateSpanNo: {
    text: "不",
  },
  ageGateSpanYes: {
    text: "是的",
  },
  instruction1: {
    text: "調高音量",
  },
  instruction2: {
    text: "讓我們開始吧",
  },
  privacyPolicyTitle: {
    text: "您确认要退出此次体验吗？",
  },
  sampleRoom: {
    text: "⻛味进化论",
  },
};
export default cn;
